module.exports = __webpack_public_path__ + "static/bg-circleTattoo-f74705a86409e6c0c376c0b53a85b3aa.png";